import { createContext } from 'react';

import { useAppConfigContext } from '../../../../providers/is-idm-provider/app-config-provider';

import { useInFieldLocationConfig } from './use-infield-location-config';

/**
 * The context can be used to inject any kind of
 * dependency, but mainly hooks and components/containers.
 *
 * The main purpose is to facilitate testing
 * and storybooking without having to make complex mocks
 * - and to keep the components as simple as possible.
 */

export interface UseFeatureToggleConfigContextInterface {
  useAppConfigContext: typeof useAppConfigContext;
  useInFieldLocationConfig: typeof useInFieldLocationConfig;
}

let context: React.Context<UseFeatureToggleConfigContextInterface>;

export const getFeatureToggleConfigContext = () => {
  if (!context) {
    context = createContext({
      useAppConfigContext,
      useInFieldLocationConfig,
    });
  }

  return context;
};
